import { render } from "./AnnualLeaves.vue?vue&type=template&id=7aec82e6"
import script from "./AnnualLeaves.vue?vue&type=script&lang=js"
export * from "./AnnualLeaves.vue?vue&type=script&lang=js"

import exportComponent from "/builds/springup/oa-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__